import { AuthenticatedLayout } from "features/common/components/AuthendicatedLayout";
import { UserPanel } from "features/user/components/UserPanel";

export const Home = () => {
  return (
    <AuthenticatedLayout>
      <UserPanel />
    </AuthenticatedLayout>
  );
};
